import { extractUrlFromIconJsonLd } from '@atlaskit/link-extractors';
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */
var extractUrlIcon = function extractUrlIcon(icon, label) {
  var url = icon && extractUrlFromIconJsonLd(icon);
  return url ? {
    label: label,
    url: url
  } : undefined;
};
export default extractUrlIcon;